import { useEffect, useState } from "react";
import { projectAuthorizationReportRepository } from "repositories/project-authorization-report-repository";

export default function useProjectAuthorizationReport() {

    const [projects, projectsSet] = useState<any>([]);
    const [organizations, organizationsSet] = useState<any>([]);
    const [appUsers, appUsersSet] = useState<any>([]);
    const [sites, sitesSet] = useState<any>([]);
    const [isData, isDataSet] = useState<boolean>(false);

  useEffect(() => {
    if (!isData) {
        projectAuthorizationReportRepository
        .singleListProject({})
        .subscribe((res) => {
            projectsSet(res?.map(item => {
                return {
                  label: `${item.code} - ${item.name}`,
                  value: item.id,
                }
              }));
        });
        projectAuthorizationReportRepository
        .singleListOrganization({})
        .subscribe((res) => {
            organizationsSet(res?.map(item => {
                return {
                  label: `${item.code} - ${item.name}`,
                  value: item.id,
                }
              }));
        });
        projectAuthorizationReportRepository
        .singleListAppUser({})
        .subscribe((res) => {
            appUsersSet(res?.map(item => {
                return {
                    label: `${item.username} - ${item.displayName} - ${item.email}`,
                    value: item.id,
                  }
              }));
        })
        projectAuthorizationReportRepository
        .singleListSite({})
        .subscribe((res) => {
            sitesSet(res?.map(item => {
                return {
                    label: `${item.name}`,
                    value: item.id,
                  }
              }));
        });
        isDataSet(true);
    }
  }, [isData]);
    
    const filterProject = (params?: any) => {
        projectAuthorizationReportRepository
        .singleListProject(params)
        .subscribe((res) => {
            projectsSet(res?.map(item => {
                return {
                  label: `${item.code} - ${item.name}`,
                  value: item.id,
                }
              }));
        })
    };

    const filterOrganization = (params?: any) => {
        projectAuthorizationReportRepository
        .singleListOrganization(params)
        .subscribe((res) => {
            organizationsSet(res?.map(item => {
                return {
                  label: `${item.code} - ${item.name}`,
                  value: item.id,
                }
              }));
        })
    };

    const filterAppUser = (params?: any) => {
        projectAuthorizationReportRepository
        .singleListAppUser(params)
        .subscribe((res) => {
            appUsersSet(res?.map(item => {
                return {
                  label: `${item.username} - ${item.displayName} - ${item.email}`,
                  value: item.id,
                }
              }));
        })
    };

    const filterSite = (params?: any) => {
        projectAuthorizationReportRepository
        .singleListSite(params)
        .subscribe((res) => {
            sitesSet(res?.map(item => {
                return {
                    label: `${item.name}`,
                    value: item.id,
                  }
              }));
        })
    };

    return {
        projects,
        organizations,
        appUsers,
        sites,
        filterProject,
        filterOrganization,
        filterAppUser,
        filterSite,
    }
}